﻿function Material() {
  console.log('[ Material ] init');
  $(document).ready(function(){
    var type = $('.js-material__color-header.material__color-orange').data('material');
    newPrice(type);
  });
  function differPrice(type,price) {
    $('.js-material__color-header[data-type="'+type+'"]').each(function(){
      if (price > $(this).find('.js-dif').data('price')) {
      $(this).find('.js-dif').text(($(this).find('.js-dif').data('price') - price)+" ₽");
    } else if (price < $(this).find('.js-dif').data('price'))  {
      $(this).find('.js-dif').text("+"+($(this).find('.js-dif').data('price') - price)+" ₽");
    } else {
      $(this).find('.js-dif').text(price+" ₽");
    }
    if (price) {
      $(this).find('.js-dif').show();
    } else {
      $(this).find('.js-dif').hide();
    }
    $('.js-material__color-header[data-material="lether"] .js-dif').text($('.js-material__color-header[data-material="lether"] .js-dif').data('price')+" ₽");
    })
  }
  function sumPrice (e, c) {
    var aksPrice = 0;
    $('.js-aksses-input').each(function(){
      if ($(this).prop('checked')) {
        aksPrice += Number($(this).val());
      }
    })
    var embPrice = Number($('.js-embroidery__sum b').html());
    var parts = $('.js-item__banner-bnpl').data('parts') || 6;
    if ($('.js-material__color-header[data-material="lether"]').hasClass('material__color-orange')) {
      $('.js-item__banner-sum').text(e + c + aksPrice + embPrice +" ₽");
      $('.js-item__banner-bnpl').text(Math.trunc((e + c + aksPrice + embPrice)/parts));
    } else {
      if ($('.js-material__color-header[data-material="eva"]').hasClass('material__color-orange')) {
        $('.js-item__banner-sum').text(e + aksPrice + " ₽");
        $('.js-item__banner-bnpl').text(Math.trunc((e + aksPrice)/parts));
      } else {
        $('.js-item__banner-sum').text(e + aksPrice + embPrice + " ₽");
        $('.js-item__banner-bnpl').text(Math.trunc((e + aksPrice + embPrice)/parts));
      }
    }
  }
  $('.js-aksses-input').on('change',function(){
    var type = $('.js-material__color-header.material__color-orange').data('material');
    newPrice(type);
  });
  $('.js-aks-min').click(function(){
    setTimeout(function(){
      var type = $('.js-material__color-header.material__color-orange').data('material');
      newPrice(type);
    },200);
  });
  $('.js-aks-plus').click(function(){
      var type = $('.js-material__color-header.material__color-orange').data('material');
      newPrice(type);
  });
  $('.js-number-box').on('keyup',function(){
    var type = $('.js-material__color-header.material__color-orange').data('material');
    newPrice(type);
  });
  $('.js-embroidery .js-width').on('keyup',function(){
    var type = $('.js-material__color-header.material__color-orange').data('material');
    newPrice(type);
  });
  $('.js-embroidery .js-height').on('keyup',function(){
    var type = $('.js-material__color-header.material__color-orange').data('material');
    newPrice(type);
  });
  function newPrice (type) {
    let econom = 0;
    let standart = 0;
    let prem = 0;
    let fur = 0;
    let luxe = 0;
    let eva = 0;
    var lether = 0;
    var typeprice = 0;
    let code = '';
    let options = $('#ajax-place').find('.js-product-option-show').hide();

    $('.js-effects-checkbox').each(function() {
      if ($(this).children('input').prop('checked')) {
        econom += $(this).children('input').data('econom');
        standart += $(this).children('input').data('standard');
        prem += $(this).children('input').data('premium');
        fur += $(this).children('input').data('fur');
        luxe += $(this).children('input').data('luxe');
        lether += $(this).children('input').data('lether') ? $(this).children('input').data('lether') : 0;
        eva += $(this).children('input').data('eva');
        typeprice += $(this).children('input').data(type);
        code = $(this).children('input').data('code');
        if (code && options.length > 0) {
          $(options).each(function() {
            let codes = $(this).data('option_codes').split(',');
            if (codes.filter((option_code) => option_code === code).length > 0) {
              $(this).show();
            }
          });
        }
      }
    });
    $('.js-material__color-header[data-material="econom"] .js-dif').data('price', econom);
    $('.js-material__color-header[data-material="standard"] .js-dif').data('price', standart);
    $('.js-material__color-header[data-material="premium"] .js-dif').data('price', prem);
    $('.js-material__color-header[data-material="fur"] .js-dif').data('price', fur);
    $('.js-material__color-header[data-material="luxe"] .js-dif').data('price', luxe);
    $('.js-material__color-header[data-material="lether"] .js-dif').data('price', lether);
    $('.js-material__color-header[data-material="eva"] .js-dif').data('price', eva);
    $('.js-material__color-header .js-dif').each(function() {
      if ($(this).data('price')) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
    var type = $('.js-material__color-header[data-material="'+type+'"]').data('type');
    differPrice (type,typeprice);
    sumPrice (typeprice, lether);
    let comment = $('.js-material__color-header').filter('.material__color-orange').eq(0).find('.h5').text();
    comment = comment.replace(/\, РѕС‚/g, '')
    comment = comment + '\r\n';
    let $params = $('.js-material__result-part').find('.important18');
    $params.each(function(){
      comment = comment + $(this).text().replace(/\s+/g, ' ') + ' ';
      comment = comment + $(this).next('.js-material__result-block').text().replace(/\s+/g, ' ');
      comment = comment + '\r\n';
    });
    $('.js-ajax-form__link[data-comment]').data('comment', comment);
  }
  function differType (type) {
    if (type == 'econom' || type == 'standard' || type == 'premium' || type == 'fur' || type == 'luxe') {
    $('.js-effects-checkbox').each(function() {
      $(this).children('input').val($(this).children('input').data(type));
      $(this).find('.js-select__equipment-money').text($(this).children('input').data(type) + ' ₽');
    })
    }
    var type = $('.js-material__color-header.material__color-orange').data('material');
    newPrice(type);
  }
  $('.js-material-addition').click(function(){
    $('.js-material-star').addClass('material-star-open');
    $('.js-material-addition').css('display','none');
  });

  $('.material-check').on('change',function(){
    var price = $(this).val();
    var color = $(this).parent('label').parent('div').data('type');
    $('.js-material__block').removeClass('material-block-check');
    changeColor(color, price);
    $(this).parent('label').parent('div').addClass('material-block-check');
    $('.js-material__color').css('display','block');
  });

  $('.js-material-check').on('change',function(){
    var price = $(this).val();
    var type = $(this).data('material');
    var namer = $(this).attr('name');
    if ($(this).attr('name') == "material__color") {
      $('.js-material-check[name="material__color"]').parent('.color').removeClass('color-active');
      $('.js-material__block').removeClass('material-block-check');
      $('.js-material__block[data-type="'+$(this).data('type')+'"]').addClass('material-block-check');
      $('.js-material__block[data-type="'+$(this).data('type')+'"] input').prop('checked','checked');
    }
    $('.js-material__color-header[data-type="'+$(this).data('type')+'"]').removeClass('material__color-orange');
    $('.js-material__color-header[data-material="'+$(this).data('material')+'"]').addClass('material__color-orange');
    $('.js-material-check[name="'+namer+'"]').parent('.color').removeClass('color-active');
    $('.js-material__result-all div.js-result__'+$(this).data('type')).css('background-image','url('+$(this).siblings('img').attr('src')+')');
    if ($(this).siblings('img').data('hex')) {
      let hexcolor = $(this).siblings('img').data('hex');
      if (hexcolor === '#fff') {
        hexcolor = 'white'
      }
      $('.js-material__result-block[data-material="'+namer+'"] div').css('background-color',$(this).siblings('img').data('hex')).removeClass().addClass(hexcolor);
    }
	$('.js-material__result-block[data-material="'+namer+'"] div').css('background-image','url('+$(this).siblings('img').attr('src')+')');
    $('.js-material__result-block[data-material="'+namer+'"] span').text($(this).data('name'));
    $(this).parent(".color").addClass('color-active');
    differType(type);
  });
  $(".js-item__banner-bottom").click(function () {
    let anim = $(this).data('href');
    let topanim = $(anim).offset().top - 140;
		$("body,html").animate({scrollTop: topanim}, 800);
  });
  $(".js-anchor-link").click(function () {
    let anim = $(this).data('href');
    let topanim = $(anim).offset().top - 140;
    $("body,html").animate({scrollTop: topanim}, 800);
  });
  $('.js-effects-checkbox .js-check').on('change',function(){
    $(this).parent('label').toggleClass('item__equipment-select');
    if ($(this).prop('checked')) {
      $('.js-item__banner-sum').text(Number($(this).val()) + Number($('.js-item__banner-sum').text().replace(' ₽','')) + ' ₽');
      var parts = $('.js-item__banner-bnpl').data('parts') || 6;
      $('.js-item__banner-bnpl').text(Math.trunc(+$('.js-item__banner-sum').text().replace(' ₽','')/parts));
    }
    var type = $('.js-material__color-header.material__color-orange').data('material');
    differType(type);
  });
  $(document).on('scroll',function(){
    var topOfset = $(document).scrollTop();
    $('.js-item-section').each(function() {
      if ((($(this).position().top + $(this).height()) > topOfset + 140) && (topOfset + $(window).height() / 2 >= $(this).position().top) ) {
        $('.js-item__banner-bottom[data-href="#'+$(this).attr('id')+'"]').addClass('item__banner-link--active');
      } else {
        $('.js-item__banner-bottom[data-href="#'+$(this).attr('id')+'"]').removeClass('item__banner-link--active');
      }
    })
  });
  $('.js-block-closer').click(function () {
    $(this).parent().toggleClass('item-selectequip--closer');
    $(this).toggleClass('item__block-open');
    $(this).siblings('.js-close-wrap').slideToggle();
    if ($(this).parent().find('.js-slider-big').html()) {
      InitSlider('.js-slider-big', {
        slidesToShow:1,
        slidesToScroll:1,
        arrows:false,
        asNavFor: '.js-slider-little',
      });
    }
    if ($(this).parent().find('.js-slider-little').html()) {
      InitSlider('.js-slider-little', {
        slidesToShow:5,
        slidesToScroll:1,
		//infinite: false,
        //centerMode: true,
        arrows:true,
        focusOnSelect: true,
        //centerPadding:5,
        asNavFor: '.js-slider-big',
        prevArrow:'<div class="item__slider--prev"></div>',
        nextArrow:'<div class="item__slider--next"></div>'
      });      
    }
  });

  $('.js-slider-big').each(function() {
    InitSlider(this, {
      slidesToShow:1,
      slidesToScroll:1,
      arrows:false,
      asNavFor: '.js-slider-little',
    });
  });
  $('.js-slider-little').each(function() {
    InitSlider(this, {
      slidesToShow:5,
      slidesToScroll:1,
	  //infinite: false,
      //centerMode: true,
      arrows:true,
      focusOnSelect: true,
      //centerPadding:5,
      asNavFor: '.js-slider-big',
      prevArrow:'<div class="item__slider--prev"></div>',
      nextArrow:'<div class="item__slider--next"></div>'
    });
  });
  function InitSlider(item, params) {

    if ($('.js-item-section').find(item).length > 0) {
      if ($(item).not('.slick-initialized')) {
        $(item).slick(params);
      } else {
        $(item).slick('unslick');
        $(item).slick(params);
      }
    }
  }
};

export {
  Material
};
